module.exports = __webpack_public_path__ + "static/media/oberflex-wengereconstitue-1200x2490.17e0aaed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-wengereconstitue-1200x2490.jpg
// module id = 1064
// module chunks = 37